:host {
    display: block;
    width: 100%;
}

.tile-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: stretch;

    // Desktop layout: wide tiles take full width, normal tiles take half width
    @media (min-width: 800px) {
        ::slotted(ux-iws-nb-contact-tile:not(.is-wide)) {
            flex: 0 0 calc(50% - 10px);
        }

        ::slotted(.is-wide) {
            flex: 0 0 100%;
        }
    }

    // Mobile layout: all tiles take full width
    @media (max-width: 799px) {
        flex-direction: column;
        gap: 15px;

        ::slotted(ux-iws-nb-contact-tile) {
            flex: 0 0 100%;
        }
    }
}
